import { NuqsAdapter } from 'nuqs/adapters/react'
import { ReviewEvaluateV2Provider } from './context/ReviewEvaluateV2Provider'
import { ReviewEvaluateV2Main } from './components/ReviewEvaluateV2Main'

export const EvaluateV2 = () => (
  <NuqsAdapter>
    <ReviewEvaluateV2Provider>
      <ReviewEvaluateV2Main />
    </ReviewEvaluateV2Provider>
  </NuqsAdapter>
)
